export const getImageUrl = url => {
  if (url) {
    let newUrl = url.split("-")
    newUrl = `${newUrl.slice(1, newUrl.length - 1).join("-")}.${
      newUrl[newUrl.length - 1]
    }`
    return `https://cdn.sanity.io/images/${process.env.SANITY_PROJECT_ID}/${process.env.SANITY_DATASET}/${newUrl}?auto=format`
  }
  return ""
}
